import React from 'react';
import './Blog.css';
import blogImg from '../../images/tour image/tour-img2.jpg';

const Blog = () => {
    return (
        <div id="blog">
            <h2 className="fs-1 text-center my-5">Blog Details</h2>
            <div className="blog-container">
                <div className="blog-img">
                    <img src={blogImg} alt="" />
                    <div className="pt-3 blog-btn">
                        <div><button className="Btn">29 DEC, 2021</button></div>
                        <div><p>By Admin</p></div>
                        <div><p>3 Comments</p></div>
                    </div>
                    <h1 className="my-3">Tips To Reduce Your Travel Costs</h1>
                    <p>There are many variations of passages of lorem ipsum available but the majority have suffered alteration.
                    sum, sed ornare nunc leo nec ipsum
                    Fusce quis nulla volutpat, rhoncus ligula ut, pulvinar nisi. In dapibus urna sit amet accumsan tristique.</p>
                </div>
                <div>
                <nav className="navbar navbar-light">
                    <div className="blog-input container-fluid">
                        <form className="d-flex">
                        <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                        <button className="border btn-outline-success" type="submit"><i className="fas fa-search fs-4"></i></button>
                        </form>
                    </div>
                </nav>
                    <h2 className="my-3">Categories</h2>
                    <li className="text-style">Best Package</li>
                    <hr className="hr" />
                    <li className="text-style">Destinations</li>
                    <hr className="hr"/>
                    <li className="text-style">Discover</li>
                    <hr className="hr"/>
                    <li className="text-style">Travel</li>
                    <hr className="hr"/>
                    <li className="text-style">Trendy</li>
                    <hr className="hr"/>
                    <li className="text-style">Popular</li>
                    <hr className="hr"/>
                    <li className="text-style">Events</li>
                </div>
            </div>
        </div>
    );
};

export default Blog;